import type { FC, HTMLAttributes } from "react";

export type FormGroupUIProps = HTMLAttributes<HTMLElement>;

export const FormGroupUI: FC<FormGroupUIProps> = ({ children, className }) => {
  return (
    <div className={`flex flex-col items-start gap-4 ${className}`}>
      {children}
    </div>
  );
};
